export interface IState {
  title: string;
  titleUri: string;
  hideTopLevel: boolean;
  hasThirdLevel: boolean;
  chaptersArray: IChapter[];
}

export interface IChapter {
  title: string;
  uri: string;
  isCurrent: boolean;
  hasCurrentChildren: boolean;
  subChapters: ISubChapter[];
}

export interface ISubChapter {
  title: string;
  uri: string;
  isCurrent: boolean;
}

const deafultState: IState = {
  title: "",
  titleUri: "",
  hideTopLevel: false,
  hasThirdLevel: false,
  chaptersArray: [],
};

export default deafultState;
